<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">组织机构</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="组织名称" prop="deptName">
            <el-input
              v-model="queryParams.deptName"
              placeholder="请输入组织名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-select
              v-model="queryParams.status"
              placeholder="组织状态"
            >
              <el-option
                v-for="dict in dict.type.permission_status"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label class="right">
            <el-button @click="handleQuery">搜 索</el-button>
            <el-button @click="resetQuery">重 置</el-button>
            <el-button @click="handleAdd">新 增</el-button>
            <el-button @click="toggleExpandAll">展开/折叠</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>

      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              v-if="refreshTable"
              v-loading="loading"
              :data="deptList"
              row-key="deptId"
              :default-expand-all="isExpandAll"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >
              <el-table-column prop="deptName" label="组织名称" width="260"></el-table-column>
              <el-table-column prop="orderNum" label="排序" width="200"></el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.status"
                    active-value="0"
                    inactive-value="1"
                    @change="handleStatusChange(scope.row)"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" align="center" prop="createTime" width="200">
                <template slot-scope="scope">
                  <span>{{ parseTime(scope.row.createTime) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-edit-outline"
                    @click="handleUpdate(scope.row)"
                  >编辑</el-button>
                  <el-button
                    type="text"
                    icon="el-icon-plus"
                    @click="handleAdd(scope.row)"
                  >新增</el-button>
                  <el-button
                    v-if="scope.row.parentId !== '0'"
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>

    <!-- 添加或修改组织 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px" v-if="open">
        <el-row>
          <el-col :span="24" v-if="form.parentId !== '0'">
            <el-form-item label="上级组织" prop="parentId">
              <treeselect @select="selectParentId" v-model="form.parentId" :options="deptOptions" :noResultsText="toolTip" placeholder="选择上级组织" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="组织名称" prop="deptName">
              <el-input v-model="form.deptName" placeholder="请输入组织名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="显示排序" prop="orderNum">
              <el-input-number v-model="form.orderNum" controls-position="right" :min="0" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="负责人" prop="leader">
              <el-input v-model="form.leader" placeholder="请输入负责人" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入联系电话" maxlength="11" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" placeholder="请输入邮箱" maxlength="50" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组织状态">
              <el-radio-group v-model="form.status">
                <el-radio
                  v-for="dict in dict.type.permission_status"
                  :key="dict.value"
                  :label="dict.value"
                >{{dict.label}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
      <!-- 密码二次确认框 -->
    <el-dialog :title="title2" :visible.sync="isShowPasswordDialog" width="600px" append-to-body>
      <el-form ref="form" :model="form2" :rules="rules2" label-width="80px" v-if="isShowPasswordDialog">    
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="用户名称"
              prop="loginName"
            >
              <el-input
                v-model="form2.loginName"
                placeholder="请输入用户名称"
                maxlength="30"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="用户密码"
              prop="password"
            >
              <el-input
                v-model="form2.password"
                placeholder="请输入用户密码"
                type="password"
                maxlength="20"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmPassword">确 定</el-button>
        <el-button @click="cancel2">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { listDept, getDeptById, addDept, updateDept, delDept, deptTreeData } from "@/api/system/permission/dept";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { login } from "@/api/system/permission/login";
export default {
  name: "DeptView",
  controller: "UI",
  action: "DeptView",
  dicts: ['permission_status'],
  components: { Treeselect },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 表格树数据
      deptList: [],
      // 是否展开，默认全部展开
      isExpandAll: true,
      // 重新渲染表格状态
      refreshTable: true,
      // 查询参数
      queryParams: {
        deptName: '',
        status: null
      },
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 部门树选项
      deptOptions: [],
      // 提示文本
      toolTip: '没有匹配的搜索结果',
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        parentId: [
          { required: true, message: "上级组织不能为空", trigger: "blur" }
        ],
        deptName: [
          { required: true, message: "组织名称不能为空", trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "显示排序不能为空", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur"]
          }
        ],
        phone: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
      },
       isSecondConfirm:false, //红旗坊要求二次输入密码确认
       // 弹出层标题
      title2: "请输入密码",
      isShowPasswordDialog:false,
      form2:{
        loginName: sessionStorage.getItem("userName"),
        password:"",
      },
      rules2: {
        loginName: [
          {
            required: true,
            message: "用户名称不能为空",
            pattern: "[^ \x22]+",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "用户密码不能为空",
            trigger: "blur",
          }
        ],
      },
      confirmType:""
    };
  },
  created() {
    this.getList();
    this.getTreeData();
  },
  methods: {
    // 监听上级组织，取消验证
    selectParentId(){
      this.$refs['form'].clearValidate('parentId');
    },
    getTreeData(){
      deptTreeData().then(response => {
        this.deptOptions = response.data;
      });
    },
    // 查询部门列表
    getList() {
      this.loading = true;
      listDept(this.queryParams).then(response => {
        this.deptList = this.handleTree(response.data, "deptId");
        this.loading = false;
      });
    },
    // 搜索
    handleQuery() {
      this.getList();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 新增
    handleAdd(row) {
      this.reset();
      this.$nextTick(() => {
        if(row.deptId != undefined){
          this.form.parentId = row.deptId;
        }
      });
      this.title = "添加组织";
      this.open = true;
    },
    // 展开/折叠
    toggleExpandAll() {
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(() => {
        this.refreshTable = true;
      });
    },

    // 组织状态修改
    handleStatusChange(row) {  //点击之后判断停用/启用
      let text = row.status == "0" ? "启用" : "停用";
      this.$confirm('确认要' + text + '"' + row.deptName + '"组织吗？').then(function() {
        return updateDept({deptId: row.deptId, parentId: row.parentId, status: row.status});
      }).then(() => {
        this.$message({type: "success", message: text + "成功"});
      }).catch(() => {
        row.status = row.status === "0" ? "1" : "0";
      });
    },
    // 行修改
    handleUpdate(row) {
      this.reset();
      getDeptById(row.deptId).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改组织";
      });
    },
    // 行删除
    handleDelete(row) {
      let that=this;
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
        if(global.$config.app.project=="hongqifang"){
            that.isShowPasswordDialog = true;
            that.confirmType="dell"
            that.currentRow = row;
            // alert( that.isShowPasswordDialog)
            // return
          }else{
            return delDept(row.deptId);
          }
        
      }).then(() => {
        if(global.$config.app.project!="hongqifang"){
          this.$message({type: "success", message: "删除成功!"});
          this.getList();
          this.getTreeData();
        }
      }).catch(() => {});
    },
    
    // 表单重置
    reset() {
      this.form = {
        deptId: null,
        parentId: undefined,
        deptName: null,
        orderNum: null,
        leader: null,
        phone: null,
        email: null,
        status: "0"
      };
      this.resetForm("form");
    },
    // 提交
    submitForm() {
      this.$refs["form"].validate(valid => {
        // console.log(this.$refs["form"])
        // console.log(this.form)
        if (valid) {
         if(global.$config.app.project=="hongqifang"&&!this.isSecondConfirm){
            this.isShowPasswordDialog = true;
            return
         }
          if (this.form.deptId != null) {
            updateDept(this.form).then(response => {
              this.$message({type: "success", message: "修改成功"});
              this.open = false;
              this.getList();
              this.isSecondConfirm=false;
               this.$refs.form.clearValidate();
            }).catch((err)=>{
              console.log(err)
              this.isSecondConfirm=false;
               this.$refs.form.clearValidate();
            }).finally(() => {
              // this.submitLoading = false;
              // 重置表单验证状态
                    this.$refs["form"].clearValidate();
            });
          } else {
            addDept(this.form).then(response => {
              this.$message({type: "success", message: "新增成功"});
              this.open = false;
              this.getList();
              this.getTreeData();
              this.isSecondConfirm=false;
              this.$refs["form"].clearValidate();
            }).catch((err)=>{
              console.log(err)
              this.isSecondConfirm=false;
               this.$refs.form.clearValidate();
            }).finally(() => {
              // this.submitLoading = false;
              // 重置表单验证状态
               this.$refs["form"].clearValidate();
            });
          }
        }
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    confirmPassword(){
      let that = this;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          login(this.form2).then((res) => {
            // console.log("登录结果",res)
            if(res.code==0||res.code==200){
              that.isSecondConfirm=true;
               that.cancel2();
               if(that.confirmType=="dell"){ 
                 delDept(that.currentRow.deptId).then(res=>{
                  //  console.log("删除res",res)
                   if(res.code==200){
                    that.confirmType=""
                     that.getList()
                   }else{
                    that.confirmType=""
                   }
                 })
               }else{
                  that.submitForm()
               }
               
            }
          });
        }
      });
    },
      // 取消按钮
    cancel2() {
      this.isShowPasswordDialog = false;
      this.form2.password = "";
    },
  }
};
</script>
<style scoped>
::v-deep .zj-layout-main{
  padding: 2.8rem;
}
</style>